export const URL_QUERY_PARAMS = {
  TAB: 'tab',
  NAME: 'name',
  PAGE: 'page',
  START_CURSOR: 'startCursor',
  END_CURSOR: 'endCursor',
} as const

export type UrlQueryParamKey =
  typeof URL_QUERY_PARAMS[keyof typeof URL_QUERY_PARAMS]

